import { toast as sonnerToast } from "sonner";

type ToastInput = {
  title: string;
  message?: string;
  color?: "green" | "red" | "yellow" | "blue";
};

export const toast = {
  show: ({ title, message, color }: ToastInput) => {
    const description = message ?? undefined;
    if (color === "red") {
      sonnerToast.error(title, { description });
      return;
    }
    if (color === "yellow") {
      sonnerToast.warning(title, { description });
      return;
    }
    if (color === "green") {
      sonnerToast.success(title, { description });
      return;
    }
    sonnerToast(title, { description });
  }
};
